import React from 'react';


const HeaderLandingNuevo = () => {

    return (

        <>
            <div className='justify-center flex sm:pt-0'>

                <div className='fixed flex justify-between w-full sm:top-6 w1500 sm:m-auto px-4 pt-2 z-20'>

                    <img
                        className='bg-white rounded-full py-[10px] px-6 z-50 md:w-[180px] w-[160px]'
                        src="/assets/img/gana-energia-logo-fix.svg"
                        width={180}
                        height={50}
                        alt="gana energia logo"
                    />

                    <div className="flex items-center z-10 gap-5 md:px-2 px-1">

                        <a href={`tel:900535689`} className='md:text-base text-sm colNeg100 bgVer500 rounded-full h-12 flex items-center px-7'>
                            900 535 689
                        </a>
                    </div>

                </div>

                <p
                    className='colVer500 text-sm hidden md:flex absolute sm:top-12 sm:right-[210px]'
                    style={{ zIndex: 10 }}
                >
                    Teléfono gratuito
                </p>

            </div>

        </>

    )
}

export default HeaderLandingNuevo
